import { authFetch } from "./authApi";

function qs(params = {}) {
    const q = new URLSearchParams();

    for (const [key, value] of Object.entries(params)) {
        if (value === undefined || value === null || value === "") continue;
        q.set(key, String(value));
    }

    const s = q.toString();
    return s ? `?${s}` : "";
}

export async function fetchRekoRaces({ seriesKey = "gt3x", seasonKey = "" } = {}) {
    return authFetch(`/api/reko/races${qs({ series_key: seriesKey, season_key: seasonKey })}`, {
        method: "GET",
    });
}

export async function fetchRekoDrivers({ seriesKey = "gt3x", seasonKey = "" } = {}) {
    return authFetch(`/api/reko/drivers${qs({ series_key: seriesKey, season_key: seasonKey })}`, {
        method: "GET",
    });
}

export async function fetchRekoRules() {
    return authFetch("/api/reko/rules", {
        method: "GET",
    });
}

export async function fetchRekoAdminCases({ raceId }) {
    return authFetch(`/api/reko/admin/cases${qs({ race_id: raceId })}`, {
        method: "GET",
    });
}

export async function fetchRekoCases({ raceId }) {
    return authFetch(`/api/reko/cases${qs({ race_id: raceId })}`, {
        method: "GET",
    });
}

export async function createRekoAdminCase(payload) {
    return authFetch("/api/reko/admin/cases", {
        method: "POST",
        body: JSON.stringify(payload),
    });
}

export async function updateRekoAdminCase(caseId, payload) {
    return authFetch(`/api/reko/admin/cases/${caseId}`, {
        method: "PATCH",
        body: JSON.stringify(payload),
    });
}

export async function deleteRekoAdminCase(caseId) {
    return authFetch(`/api/reko/admin/cases/${caseId}`, {
        method: "DELETE",
    });
}

export async function openBulkRekoAdminCases({ raceId }) {
    return authFetch("/api/reko/admin/cases/open-bulk", {
        method: "POST",
        body: JSON.stringify({ race_id: raceId }),
    });
}

export async function fetchRekoOpenCount() {
    return authFetch("/api/reko/my-open-count", {
        method: "GET",
    });
}

export async function saveRekoOpinion(caseId, payload) {
    return authFetch(`/api/reko/cases/${caseId}/opinion`, {
        method: "POST",
        body: JSON.stringify(payload),
    });
}

export async function fetchRekoLeadOpinions(caseId) {
    return authFetch(`/api/reko/lead/cases/${caseId}/opinions`, {
        method: "GET",
    });
}

export async function saveRekoLeadFinalDecision(caseId, payload) {
    return authFetch(`/api/reko/lead/cases/${caseId}/final-decision`, {
        method: "POST",
        body: JSON.stringify(payload),
    });
}

export async function publishRekoLeadFinalDecision(caseId) {
    return authFetch(`/api/reko/lead/cases/${caseId}/publish`, {
        method: "POST",
    });
}

export async function reopenRekoLeadCase(caseId) {
    return authFetch(`/api/reko/lead/cases/${caseId}/reopen`, {
        method: "POST",
    });
}

export async function fetchProtestOptions({ seriesKey = "gt3x", seasonKey = "" } = {}) {
    return authFetch(`/api/reko/user/protest-options${qs({
        series_key: seriesKey,
        season_key: seasonKey,
    })}`, {
        method: "GET",
    });
}

export async function createUserProtest(payload) {
    return authFetch("/api/reko/user/protests", {
        method: "POST",
        body: JSON.stringify(payload),
    });
}